module.exports = __webpack_public_path__ + "static/media/baseball.565d5842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/baseball.jpg
// module id = 685
// module chunks = 0